import React, { useEffect, useState } from 'react';
import { useLocation } from '@common/hooks';
import { ENV_VARS } from '@common/services';

// NOTE: config/environments holds only development, production and test, so
// staging and review apps report RAILS_ENV=production here too.
const isProduction = ENV_VARS.RAILS_ENV === 'production';

function extractBasePath(path: string) {
  return path.split('/')[2];
}

function reloadPageWithRoute(route: string) {
  window.location.href = route;
}

async function getLastDeploySha(retrieveLastSha: (sha: string) => void) {
  const endpointUrl = '/version.json';

  try {
    const response = await fetch(endpointUrl);
    const result = await response.json();
    retrieveLastSha(result?.sha);
  } catch (e) {
    console.error('Error trying to fetch last deploy version: ', e);
  }
}

const SIX_HOURS = 6 * 60 * 60 * 1000;

export function ChunkVersionController() {
  const location = useLocation();
  const [previousPath, setPreviousPath] = useState('');
  const [initialDeployHash, setInitialDeployHash] = useState('');
  const [serverDeployHash, setServerDeployHash] = useState('');

  useEffect(() => {
    if (!isProduction) {
      return;
    }

    getLastDeploySha((hash) => {
      setInitialDeployHash(hash);
      setServerDeployHash(hash);
    });

    const intervalId = setInterval(() => {
      getLastDeploySha(setServerDeployHash);
    }, SIX_HOURS);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const currentBasePath = extractBasePath(location.pathname);
    const previousBasePath = extractBasePath(previousPath);

    if (
      previousPath &&
      initialDeployHash &&
      serverDeployHash &&
      initialDeployHash !== serverDeployHash &&
      currentBasePath !== previousBasePath
    ) {
      reloadPageWithRoute(`${origin}${location.pathname}`);
    } else {
      setPreviousPath(location.pathname);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, initialDeployHash, serverDeployHash]);

  return <></>;
}
